import { BookingCard } from "@/src/components/wrappers/BookingCard";
import { Booking } from "../../model";
import { Button } from "@/src/components/ui/button";
import { CopyIcon, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";

const ExternalBookingLinksSection = ({
  hubspotId,
  bookingId,
  handleCopyToClipboard,
  bookingSlug,
  offerId,
  dealLink,
  brand,
}: {
  hubspotId: string;
  bookingId: string;
  bookingSlug: string;
  offerId: string;
  dealLink: string;
  handleCopyToClipboard: (text: string) => void;
  brand: Booking["brand"];
}) => {
  const customerBookingUrl =
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
      ? `https://${brand}-web-test.adchitects.co/booking/details/${bookingSlug}`
      : `https://${brand}.yt/booking/details/${bookingSlug}`;
  const customerBookingSummaryUrl =
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
      ? `https://${brand}-web-test.adchitects.co/booking/summary/${offerId}`
      : `https://${brand}.yt/booking/summary/${offerId}`;

  // The stored offer.dealLink can be empty (offer built without a deal) or, from a
  // historical env gap, the literal "undefined<id>". Fall back to building the
  // record URL from the booking's deal id so the card always reaches HubSpot.
  const dealHref = /^https?:\/\//.test(dealLink ?? "")
    ? dealLink
    : hubspotId
      ? `https://app-eu1.hubspot.com/contacts/143390230/record/0-3/${hubspotId}`
      : "";

  return (
    <div className="flex w-full gap-6">
      {!!dealHref && (
        <BookingCard className="flex grow gap-6 items-center justify-between">
          <Button className="text-black p-0 text-base font-medium" variant="link">
            <a href={dealHref} target="_blank" rel="noreferrer" className="flex">
              Deal Record <ExternalLink className="ml-1.5" size={20} />
            </a>
          </Button>
        </BookingCard>
      )}
      <BookingCard className="flex grow gap-6 items-center justify-between">
        <span className="text-base">Xero ID</span>
        <span
          onClick={(e) => {
            handleCopyToClipboard(e.currentTarget.innerText);
          }}
          className="flex items-center text-base text-base gap-2 cursor-pointer"
        >
          <span className="font-medium line-clamp-1 break-all">{bookingSlug || "N/A"}</span>
          <CopyIcon size={20} className="stroke-slate-500 min-w-6" />
        </span>
      </BookingCard>
      <BookingCard className="flex grow  gap-6 items-center justify-between">
        <Button className="text-black p-0 text-base font-medium" variant="link">
          <Link to={customerBookingUrl} target="_blank" className="flex">
            User's Booking page
            <ExternalLink className="ml-1.5" size={20} />
          </Link>
        </Button>
      </BookingCard>
      <BookingCard className="flex grow gap-6 items-center justify-between">
        <Button className="text-black p-0 text-base font-medium" variant="link">
          <Link to={customerBookingSummaryUrl} target="_blank" className="flex">
            User's Booking summary
            <ExternalLink className="ml-1.5" size={20} />
          </Link>
        </Button>
      </BookingCard>
    </div>
  );
};

export default ExternalBookingLinksSection;
